import tooltips from '@assets/css/tooltips.css';

/**
 * Tooltips styles.
 * @type {CSSStyleSheet}
 */
export const tooltipsStyles = new CSSStyleSheet();
tooltipsStyles.replaceSync(tooltips);
